export const PAGE_READY = 'global:pageready';
export const PAGE_LOADED = 'global:page_loaded';
export const CLICK = 'global:click';
export const SCROLL = 'global:scroll';
export const READY = 'global:ready';
export const KEYUP = 'global:keyup';
export const RESIZE = 'global:resize';
export const UPDATE = 'global:update';
export const CHANGE = 'global:change';
export const TOUCHMOVE = 'global:touchmove';
export const TOUCHSTART = 'global:touchstart';
export const MOUSEOVER = 'global:mouseover';
export const MOUSEOUT = 'global:mouseout';
export const MOUSEENTER = 'global:mouseenter';
export const MOUSELEAVE = 'global:mouseleave';
export const UPDATE_STATS = 'global:updatestats';
export const SHOW_OVERLAY = 'global:show-overlay';
export const HIDE_OVERLAY = 'global:hide-overlay';
export const TRANSITIONEND = 'global:transitionend';
export const ANIMATIONEND = 'global:animationend';
export const PRESS = 'global:press';
export const TAP = 'global:tap';
export const DOUBLETAP = 'global:doubletap';
export const OWLTRANSLATED = 'global:owltranslated';
export const OWLCHANGE = 'global:owlchange';
export const OWLCHANGED = 'global:owlchanged';
export const OWLRESIZE = 'global:owlresize';
export const OWLINITIALIZE = 'global:owlinitialize';
export const OWLINITIALIZED = 'global:owlinitialized';
export const INPUTBLUR = 'global:blurinput';
export const INPUTFOCUS = 'global:focusinput';
export const SUBMIT = 'global:submitform';
export const FORMCHANGE = 'global:changeform';
export const FORMFOCUSIN = 'global:focusinform';
export const FORMFOCUSOUT = 'global:focusoutform';
export const RENDER_LAZY_IMAGES = 'global:render-lazy-images';
export const RENDER_CAROUSEL_IMAGES = 'global:render-carousel-images';
export const RENDER_SLIDE_IMAGES = 'global:render-slide-images';
export const RENDER_VIDEOS = 'global:render-videos';
export const RERENDER_ALL = 'global:rerender-all';
export const BUTTON_FAVORITE_READY = 'global:button-favorite-ready';
export const FAVORITE_TEAMS_UPDATED = 'global:updatefavoriteteams';
export const FAVORITE_REPORTERS_UPDATED = 'global:updatefavoritereporters';
export const FAVORITES_UPDATED = 'global:updatefavorites';
export const FAVORITES_SAVED = 'global:savedfavorites';
export const FAVORITES_RETRIEVED = 'global:favoritesretrieved';
export const UPDATE_FAVORITE = 'global:updatefavorite';
export const BUTTON_FAVORITE_CLICK = 'global:button-favorite-click';
export const CHANGED_TABS = 'global:changedtabs';
export const FEED_LOADED = 'global:feedcomponentloaded';
export const REGISTER_PAGE_VIEW = 'global:registerpageview';
export const REFRESH_ADS = 'global:refreshads';
export const REFRESH_ADHESION = 'global:refreshadhesion';
export const GEORESPONSE = 'global:geolocationresponse';
export const RENDER_DROPDOWNS = 'global:render_dropdowns';
export const VIDEO_PLAYER_UPDATE = 'global:video_player_update';
export const VIDEO_PLAYER_PLAY = 'global:video-player-play';
export const VIDEO_PLAYER_PAUSE = 'global:video-player-pause';
export const MOUSEUP = 'global:mouseup';
export const MOUSEDOWN = 'global:mousedown';
export const MOUSEMOVE = 'global:mousemove';
export const HASHCHANGE = 'global:hashchange';
export const AUTOCOMPLETE_SELECT = 'global:autocomplete-select';
export const OUTBRAIN = 'global:outbrain';
export const OUTBRAIN_REFRESH = 'global:oubtrain-refresh';
export const OUTBRAIN_ENDSLATE_RENDER = 'global:oubtrain-endslate-render';
export const OUTBRAIN_ENDSLATE_DESTROY = 'global:oubtrain-endslate-destroy';
export const OPEN_POPUP = 'global:open-popup';
export const NAV_MOVED = 'global:nav-moved';
export const NAV_INITIALIZED = 'global:nav-initialized';
export const DISPLAY_GALLERY = 'global:display-gallery';
export const BREAKPOINT_CHANGED = 'global:breakpoint-changed';
export const SLIDE_CHANGED = 'global:slide-changed';
export const GLIDE_SLIDE_CLICK = 'global:glide-click';
export const GO_TO_SLIDE = 'global:go-to-slide';
export const CLOSE_MODAL = 'global:close-modal';
export const CSS_FONTS_LOADED = 'global:css-fonts-loaded';
export const ASYNC_CSS_LOADED = 'global:async-css-loaded';
export const BLOCKING_CSS_LOADED = 'global:blocking-css-loaded';
export const CIRCULAR_COUNTDOWN_LOADED = 'global:circular-countdown-loaded';
export const CIRCULAR_COUNTDOWN_START = 'global:circular-countdown-start';
export const CIRCULAR_COUNTDOWN_COMPLETE = 'global:circuar-countdown-complete';
export const LAZY_IMAGE_LOADED = 'global:lazy-image-loaded';
export const AUTO_ADVANCE_LOADED = 'global:autoadvanceloaded';
export const EMBED_INSTAGRAM_LOADED = 'global:social-embed-loaded';
export const RECIRC_LOADED = 'global:recirc-loaded';
export const RECIPE_REVIEWS_LOADED = 'global:recipe-reviews-loaded';
export const RECIPE_REVIEWS_UPDATED = 'global:reviews-updated';
export const REFRESH_TOPICS_CAROUSEL = 'global:refresh-topics-carousel';
export const CLAMP_LINES = 'global:clamp-lines';
export const REFRESH_DOCKED_SHAREBAR = 'global:refresh-docked-sharebar';
export const UGC_MANAGER_RATE = 'global:ugc-manager-rate';
export const UGC_MANAGER_COMMENT = 'global:ugc-manager-comment';
export const AUTHENTICATED = 'global:authentication-complete';
export const UGC_UPLOAD_MODAL_ACTIVATE = 'global:ugc-upload-modal-activate';
export const UGC_PHOTO_UPLOAD_GET_ID = 'global:ugc-photo-upload-get-unique-id';
export const UGC_PHOTO_UPLOAD_POST = 'global:ugc-photo-upload-post-photo';
export const CAROUSEL_SWIPE = 'global:carousel-swipe';
export const HORIZONTAL_GALLERY_RENDERED = 'global:horizontal-gallery-rendered';
export const INITIALIZE_ALERT_BANNERS = 'global:initialize-alert-banners';
export const SHOW_PRINT_PREVIEW = 'global:show-print-preview';
export const SET_RECIPE_RATING = 'global:set-recipe-rating';
export const TOGGLE_DISCLOSURE = 'global:toggle-disclosure';
